var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"cover":"","src":!_vm.src || _vm.useFallbackSrc ? _vm.fallbackSrc : _vm.src,"height":"240","width":"100%"},on:{"error":function($event){_vm.useFallbackSrc = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }